/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Period } from '../models/Period';
import type { PeriodVehicle } from '../models/PeriodVehicle';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PeriodsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns Period Periods
   * @throws ApiError
   */
  public getPeriods({
    policyId,
    dbName,
  }: {
    policyId: string,
    dbName?: string,
  }): CancelablePromise<Array<Period>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/periods',
      path: {
        'policyId': policyId,
      },
      query: {
        'dbName': dbName,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns PeriodVehicle Period Vehicles
   * @throws ApiError
   */
  public getPeriodVehicles({
    policyId,
    periodNumber,
    sortKey,
    sortOrder,
    limit,
    minimumDistanceDriven,
    dbName,
  }: {
    policyId: string,
    periodNumber: number,
    sortKey?: 'riskScore',
    sortOrder?: 'ASC' | 'DESC',
    limit?: number,
    minimumDistanceDriven?: number,
    dbName?: string,
  }): CancelablePromise<Array<PeriodVehicle>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/insights/{policyId}/periods/{periodNumber}/vehicles',
      path: {
        'policyId': policyId,
        'periodNumber': periodNumber,
      },
      query: {
        'sortKey': sortKey,
        'sortOrder': sortOrder,
        'limit': limit,
        'minimumDistanceDriven': minimumDistanceDriven,
        'dbName': dbName,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

}
